var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.227,
    height: 9.311,
    viewBox: "0 0 13.227 9.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "mail email e-mail letter"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91631",
    d: "M15.238 13a.49.49 0 0 0-.49.49v3.916a.49.49 0 0 1-.49.49H4.469a.49.49 0 0 1-.49-.49V13.49a.49.49 0 0 0-.979 0v3.916a1.471 1.471 0 0 0 1.469 1.469h9.79a1.471 1.471 0 0 0 1.469-1.469V13.49a.49.49 0 0 0-.49-.49z",
    transform: "translate(-2.75 -9.813)",
    style: {
      fill: "#6e6a65",
      stroke: "#6e6a65",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91632",
    d: "M9.168 12.776a.49.49 0 0 0 .587 0l5.781-4.337a.49.49 0 0 0 .147-.6 1.5 1.5 0 0 0-.289-.406A1.469 1.469 0 0 0 14.357 7h-9.79a1.469 1.469 0 0 0-1.038.431 1.5 1.5 0 0 0-.289.406.49.49 0 0 0 .147.6zm-4.6-4.8h9.79a.441.441 0 0 1 .137 0l-5.033 3.797-5.033-3.794a.441.441 0 0 1 .137 0z",
    transform: "translate(-2.848 -6.75)",
    style: {
      fill: "#6e6a65",
      stroke: "#6e6a65",
      strokeWidth: ".5px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.svg";
export { ForwardRef as ReactComponent };